class AutoQuantity extends HTMLElement {
  connectedCallback() {
    this.quantityElement = document.querySelector('product-info quantity-input input');
    this.selects = Array.from(this.querySelectorAll('select'));
    this.event = new Event('change', { bubbles: true });
    this.addEventListener('change', this.changeHandler.bind(this));
  }
  changeHandler() {
    this.quantity = this.selects.reduce( (acc, select) => {
        const step = +select.dataset.value;
        const val = +select.value;
        if(val) return acc + val * step;
        return acc;
    }, 0);
    this.setQuantity();
    this.quantityElement.dispatchEvent(this.event);
  }
  setQuantity() {
    this.quantityElement.value = this.quantity;
  }
}

customElements.define('quantity-selects', AutoQuantity);
